import { render, staticRenderFns } from "./HorseTranspondeur.vue?vue&type=template&id=9bb842fe&"
import script from "./HorseTranspondeur.vue?vue&type=script&lang=js&"
export * from "./HorseTranspondeur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports